var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMvidicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5405_12220)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.6154C13.2058 16.6154 16.6154 13.2058 16.6154 9C16.6154 4.79423 13.2058 1.38462 9 1.38462C4.79423 1.38462 1.38462 4.79423 1.38462 9C1.38462 13.2058 4.79423 16.6154 9 16.6154ZM9 18C13.9708 18 18 13.9708 18 9C18 4.02923 13.9708 0 9 0C4.02923 0 0 4.02923 0 9C0 13.9708 4.02923 18 9 18Z",
    fill: "#FF723D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5405_12220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.64286 6.14286H9.35714V8.28571H8.64286V6.14286ZM8.64286 9.71429H9.35714V11.8571H8.64286V9.71429ZM9.71429 8.64286H11.8571V9.35714H9.71429V8.64286ZM6.14286 8.64286H8.28571V9.35714H6.14286V8.64286ZM4.71429 6.85714H4V4.71429C4 4.52485 4.07525 4.34316 4.20921 4.20921C4.34316 4.07525 4.52485 4 4.71429 4H6.85714V4.71429H4.71429V6.85714ZM6.85714 14H4.71429C4.52485 14 4.34316 13.9247 4.20921 13.7908C4.07525 13.6568 4 13.4752 4 13.2857V11.1429H4.71429V13.2857H6.85714V14ZM13.2857 14H11.1429V13.2857H13.2857V11.1429H14V13.2857C14 13.4752 13.9247 13.6568 13.7908 13.7908C13.6568 13.9247 13.4752 14 13.2857 14ZM14 6.85714H13.2857V4.71429H11.1429V4H13.2857C13.4752 4 13.6568 4.07525 13.7908 4.20921C13.9247 4.34316 14 4.52485 14 4.71429V6.85714Z",
    fill: "#FF723D",
    stroke: "#FF723D",
    strokeWidth: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5405_12220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5405_12220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvidicon);
export default __webpack_public_path__ + "static/media/mvidicon.4573676922bdc3e428c85cd2619fc6bf.svg";
export { ForwardRef as ReactComponent };